import { AlarmListingFieldName } from './services/alarms.types';

export const alarmsTableSortField: Record<string, AlarmListingFieldName> = {
  dateTime: AlarmListingFieldName.DateTimeUtcUpdated
};
